import moment from 'moment';

import type {
  Campaign,
  MixedSelectDropdownItem
} from 'types';

export const MAX_NUM_TAGS = 6;
export const MAX_NUM_CHARS_BRIEF = 500;
export const MAX_NUM_EXCLUDED_BRANDS = 5;

export const getStatusLabelTextKey = (
  campaign: Campaign
): string => {
  const now = moment();
  const campaignStartDate = moment(campaign.timeline?.campaignStartDate);
  const goLiveDate = moment(campaign.timeline?.taskContentGoLiveDate);

  if (campaign.state === 'inactive') {
    return 'ended';
  }

  if (campaign.state === 'preparation') {
    return 'approved';
  }

  if (campaign.state === 'active' && now.isSameOrAfter(campaignStartDate) && now.isBefore(goLiveDate)) {
    return 'outfits_in_preparation';
  }

  if (campaign.state === 'active' && now.isSameOrAfter(goLiveDate)) {
    return 'live';
  }

  return 'draft';
};

export const getCountriesDropdownItems = (
  countries: Array<string> | undefined
): Array<MixedSelectDropdownItem> => (countries ?? [])
  .map(country => ({
    label: country.toUpperCase(),
    value: country,
    identifier: country,
    isDisabled: false,
    isFocused: false,
    isSelected: false
  }));
